import { render } from "./AlmSwitchRenderer.vue?vue&type=template&id=39e1becc&ts=true"
import script from "./AlmSwitchRenderer.vue?vue&type=script&lang=ts"
export * from "./AlmSwitchRenderer.vue?vue&type=script&lang=ts"

import "./AlmSwitchRenderer.vue?vue&type=style&index=0&id=39e1becc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__